import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { unsubscribeAll } from '../../app.helpers';
import AppValues from '../../app.values';

@Directive({
  selector: '[appDebounceClick]',
})
export class DebounceClickDirective implements OnInit, OnDestroy {
  @Input({ required: false }) public debounceTime: number = AppValues.DEBOUNCE_TIME;

  @Output() public debounceClick: EventEmitter<unknown> = new EventEmitter();

  private clicks: Subject<Event> = new Subject();

  private subscription: Subscription[] = [];

  @HostListener('click', ['$event'])
  public clickEvent(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }

  public ngOnInit(): void {
    this.clicks.pipe(debounceTime(this.debounceTime)).subscribe((e: Event) => this.debounceClick.emit(e));
  }

  public ngOnDestroy(): void {
    unsubscribeAll(this.subscription);
  }
}
